import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const LOG10 = () => {
  return (
    <CardSection id="LOG10" title="LOG10">
      <Paragraph>
        숫자의 밑이 10인 로그를 반환합니다. 이 함수는 Excel의 Log10 함수와
        동일한 출력을 제공합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>LOG10(NUMBER)</Paragraph>
        <Ul>
          <Li>
            <b>NUMBER</b>는 로그를 구하려는 양의 실수입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>LOG10(`Column`)</Paragraph>
        <Img src="computeLog10" />
      </ListSection>
    </CardSection>
  );
};
